<script setup lang="tsx">
const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: "#cccccc"
  }
);
</script>

<template>
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="transform-origin: center"
  >
    <rect
      x="2"
      y="15"
      width="28"
      height="2"
      rx="1"
      :fill="props.color"
    />
    <rect
      x="17"
      y="2"
      width="28"
      height="2"
      rx="1"
      transform="rotate(90 17 2)"
      :fill="props.color"
    />
  </svg>
</template>
